<template>
  <div class="scope-items-settings">
    <stacked-tabs
      class="font-cond text-center uppercase"
      :tabs="tabs"
      :selected-tab="selectedTab"
      @tab-selected="selectedTab = $event"
    />
    <component class="mt-8" :is="selectedComponent" />
    <bdg-button
      class="ghost has-icon mt-10 uppercase"
      before-icon-class="bdg-icon plus"
      @click.native="addItem"
    >
      Add Scope Item
    </bdg-button>
  </div>
</template>

<script>
import { ScopeDocumentTabs } from "../../js-data/contract-tab-groups";
import StackedTabs from "../../elements/StackedTabs";
import {
  ScopeDocumentCondensedTypes,
  ScopeDocumentTypes
} from "../../constants/contract-enums";
import DesignScopeItems from "./DesignScopeItems";
import ConstructionScopeItems from "./ConstructionScopeItems";
import ChangeOrderScopeItems from "./ChangeOrderScopeItems";
import BdgButton from "../../elements/BdgButton";
import ScopeItemForm from "../../forms/ScopeItemForm";

export default {
  name: "ScopeItemsSettings",
  components: { BdgButton, StackedTabs },
  data() {
    return {
      tabs: ScopeDocumentTabs,
      selectedTab: null
    };
  },
  computed: {
    selectedComponent() {
      if (this.selectedTab) {
        if (this.selectedTab.slug === ScopeDocumentCondensedTypes.DESIGN) {
          return DesignScopeItems;
        } else if (
          this.selectedTab.slug === ScopeDocumentCondensedTypes.CONSTRUCTION
        ) {
          return ConstructionScopeItems;
        } else if (
          this.selectedTab.slug === ScopeDocumentCondensedTypes.CHANGE_ORDER
        ) {
          return ChangeOrderScopeItems;
        }
      }
      return null;
    }
  },
  methods: {
    addItem() {
      let type;
      switch (this.selectedTab.slug) {
        case ScopeDocumentCondensedTypes.DESIGN:
          type = ScopeDocumentTypes.DESIGN_SHEETS;
          break;
        case ScopeDocumentCondensedTypes.CONSTRUCTION:
          type = ScopeDocumentTypes.CONSTRUCTION;
          break;
        case ScopeDocumentCondensedTypes.CHANGE_ORDER:
          type = ScopeDocumentTypes.CHANGE_ORDER;
          break;
        default:
          type = ``;
      }

      this.$store.commit("setCreateEditComponentParams", {
        createEditComponent: ScopeItemForm,
        createEditComponentData: { type },
        createEditComponentIsShown: true
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.scope-items-settings {
  @apply px-5 pb-6;

  @screen md {
    @apply px-8;
  }
}
</style>
